import {postCreateTournament} from '../api/postCreateTournament';

const setPostCreateTournament = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            await postCreateTournament(params);
            if (callback) {
                callback();
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreateTournament
}